import { useMutation } from "@tanstack/react-query";
import { userDelete } from "common/api/citajteo/citajteo_user";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseUserDeleteParams = {
  invalidateKeys?: string[];
  successHandle?: Function;
  errorHandle?: Function;
};

export const useUserDelete = (hookParams?: UseUserDeleteParams) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: userDeleteMutate } = useMutation({
    mutationFn: async (id: string) => {
      const response = await userDelete(id);

      if (!response) {
        throw new Error("userDelete failed");
      }

      return response;
    },
    onSuccess: (response) => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }

      if (hookParams?.successHandle) {
        hookParams.successHandle(response);
      }
    },
    onError: (error) => {
      if (hookParams?.errorHandle) {
        hookParams.errorHandle(error);
      }
    },
  });

  return { userDeleteMutate };
};
